import { Link } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import { Card, CardContent } from '../../../components/ui/Card';
import { Gauge, Upload, Calendar, Calculator } from 'lucide-react';

export default function MobileHome() {
  const { user } = useAuthStore();

  const greeting = user?.firstName || user?.email || 'User';

  const quickActions = [
    {
      to: '/tenant/mobile/mileage',
      label: 'Mileage',
      description: 'Log vehicle mileage',
      icon: Gauge,
    },
    {
      to: '/tenant/mobile/receipts',
      label: 'Receipts',
      description: 'Upload or record receipts',
      icon: Upload,
    },
    {
      to: '/tenant/mobile/planner',
      label: 'Planner',
      description: 'Job and schedule planning',
      icon: Calendar,
    },
    {
      to: '/tenant/mobile/calculators',
      label: 'Calculators',
      description: 'Electrical calculators',
      icon: Calculator,
    },
  ];

  return (
    <div className="px-4 py-6 pb-8">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-6">
        Hi, {greeting}
      </h1>

      <div className="space-y-4">
        {quickActions.map(({ to, label, description, icon: Icon }) => (
          <Link key={to} to={to}>
            <Card className="min-h-[52px] flex items-center active:opacity-90 transition-opacity bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 mt-2.5 mb-2.5">
              <CardContent className="flex items-center gap-4 p-4 w-full">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">
                  <Icon size={22} strokeWidth={2} aria-hidden />
                </div>
                <div className="flex-1 min-w-0">
                  <h2 className="text-base font-medium text-gray-900 dark:text-gray-100">
                    {label}
                  </h2>
                  <p className="text-sm text-gray-600 dark:text-gray-400 truncate">
                    {description}
                  </p>
                </div>
                <span className="sr-only">Go to {label}</span>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
